import React, { Component } from "react";
import axios from "axios";
import swal from "sweetalert";
import logo from "../assets/img/logo2.png";


import HmacSHA256 from "crypto-js/hmac-sha256";

class SendSMSUPayDogane extends Component {
  state = {
    nrKodi: "",
    cope: "",
    posts: [],
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };
 

  handleClick2 = (e) => {
 //   var d = new Date();

    const data = {
      nrKodi: this.state.nrKodi,

      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    if (this.state.nrKodi === "") {
      swal("Ju lutem vendosni numrin e podit!");
    } else {
     

      axios.post(window.UserP.url + "POD/SendSMSUPayDogane", data).then((response) => {
        this.setState({ posts: response.data[0] });
        console.log(this.state.posts);
        if (this.state.posts !== undefined) {
        this.setState({
                loading: false,
                showModal: true,
                error1: this.state.posts.ResultMessage,
                });
        }else{
            swal("Podi nuk ekziston");
        }
      });
    }
  };



  render() {
    return (
      <div className="Form">
        <div className="card card-body bg-light col-md-3">
          <label className="">Barcode</label>
          <input
            id="nrKodi"
            name="nrKodi"
            value={this.state.nrKodi}
            className="form-control "
            type="text"
            onChange={(e) => this.handleInputChange(e, "nrKodi")}
          />
        </div>

        <div className="card card-body bg-light col-md-3">
          <div className="row">
            <button
              className="btn btn-primary ml-3"
              onClick={this.handleClick2}
            >
              <span data-notify="icon" className="pe-7s-print" />
              &nbsp; Dergo SMS Dogane UPay
            </button>
          </div>
        </div>
        
      </div>
    );
  }
}

export default SendSMSUPayDogane;
